<template>
  <div class="vertical-align-wrap">
    <div class="vertical-align-middle auth-main h-100 d-flex">
      <div
        class="d-flex align-items-center justify-content-center w-100"
        style="background-color: oklch(98.4% 0.003 247.858)"
      >
        <div class="auth-box">
          <div class="top d-flex justify-content-center my-2">
            <img
              src="../../../assets/logo6.png"
              alt="Lucid"
              style="width: 50px"
            />
            <link
              href="https://fonts.googleapis.com/css2?family=Lato:wght@400&display=swap"
              rel="stylesheet"
            />
            <span
              style="
                margin-top: 19px;
                margin-left: -9px;
                color: #273061;
                display: inline-block;
                font-family: 'Lato', sans-serif;
                font-size: 20px;
              "
              >FaceScreen</span
            >
          </div>
          <div class="card shadow-lg">
            <div class="header">
              <p class="lead text-center fw-bold">Create an account</p>
            </div>
            <div class="body">
              <form class="form-auth-small" @submit.prevent="submit">
                <div class="form-group">
                  <label for="signup-email" class="control-label">Email</label>
                  <input
                    type="email"
                    class="form-control"
                    id="signup-email"
                    v-model="email"
                    placeholder="Enter Your Email"
                    required
                  />
                </div>

                <div class="form-field">
                  <label for="signup-username" class="control-label"
                    >Username</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="signup-username"
                    v-model="username"
                    placeholder="Enter Your Username"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="signup-password" class="control-label mt-2"
                    >Password</label
                  >
                  <input
                    type="password"
                    class="form-control"
                    id="signup-password"
                    v-model="password"
                    placeholder="Create a Password"
                    required
                    @input="validatePassword"
                    @focus="passwordFocused = true"
                    @blur="passwordFocused = false"
                  />
                </div>

                <div
                  v-if="passwordFocused"
                  class="password-requirements mt-2 mb-1"
                >
                  <p :class="{ valid: isLengthValid }">
                    ✔️ At least 10 characters
                  </p>
                  <p :class="{ valid: hasUppercase }">
                    ✔️ At least one uppercase letter
                  </p>
                  <p :class="{ valid: hasNumber }">✔️ At least one number</p>
                  <p :class="{ valid: hasSpecialChar }">
                    ✔️ At least one special character (@, !, %, etc)
                  </p>
                </div>

                <div class="form-group">
                  <label for="confirm-password" class="control-label mt-1"
                    >Confirm Password</label
                  >
                  <input
                    type="password"
                    class="form-control"
                    id="confirm-password"
                    v-model="confirmPassword"
                    placeholder="Re-enter Your Password"
                    required
                  />
                </div>
                <button type="submit" class="btn btn-primary btn-lg btn-block">
                  REGISTER
                </button>

                <!-- Display success or error message -->
                <div
                  v-if="statusMessage.show"
                  :class="statusMessage.class"
                  class="alert-message"
                >
                  <i :class="statusMessage.icon_class"></i>
                  <div class="message-content">
                    {{ statusMessage.icon_title }}
                  </div>
                </div>

                <div class="bottom">
                  <span class="helper-text"
                    >Already have an account?
                    <router-link to="/authentication/page-login"
                      >Login</router-link
                    >
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-logos">
      <img
        v-for="(logo, i) in footerLogos"
        :key="i"
        :src="logo"
        :alt="`logo-${i + 1}`"
        :class="[
          'footer-logo',
          {
            'footer-logo-large': i === 2,
            'footer-logo-shift': i === 0 || i === 1,
          },
        ]"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "RegisterComponent",
  data() {
    return {
      email: "",
      username: "",
      password: "",
      confirmPassword: "",
      passwordFocused: false,
      isLengthValid: false,
      hasUppercase: false,
      hasNumber: false,
      hasSpecialChar: false,
      statusMessage: {
        class: "",
        icon_class: "",
        icon_title: "",
        show: false,
      },
      footerLogos: [
        require("@/assets/Picture1.jpg"),
        require("@/assets/Picture2.png"),
        require("@/assets/Picture3.png"),
      ],
    };
  },
  methods: {
    validatePassword() {
      this.isLengthValid = this.password.length >= 10;
      this.hasUppercase = /[A-Z]/.test(this.password);
      this.hasNumber = /\d/.test(this.password);
      this.hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(this.password);
    },

    async submit() {
      this.validatePassword();

      // Check if password requirements are met
      if (
        !this.isLengthValid ||
        !this.hasUppercase ||
        !this.hasNumber ||
        !this.hasSpecialChar
      ) {
        this.statusMessage = {
          class: "alert alert-danger",
          icon_class: "fa fa-exclamation-circle",
          icon_title:
            "Password must meet all the requirements before submitting.",
          show: true,
        };
        return;
      }

      // Check if passwords match
      if (this.password !== this.confirmPassword) {
        this.statusMessage = {
          class: "alert alert-danger",
          icon_class: "fa fa-exclamation-circle",
          icon_title: "Passwords do not match! Please try again.",
          show: true,
        };
        return;
      }

      const usernameRegex = /^[a-zA-Z0-9_]+$/;
    if (!usernameRegex.test(this.username)) {
      this.statusMessage = {
        class: "alert alert-danger",
        icon_class: "fa fa-exclamation-circle",
        icon_title:
          "Username contains invalid characters. Only letters, numbers, and underscores are allowed.",
        show: true,
      };
      return;
    }

      const fasdBackendURL = process.env.VUE_APP_BACKEND_URL;
      const newUser = {
        new_user: {
          email: this.email,
          password: this.password,
          username: this.username,
        },
      };

      try {
        const response = await fetch(`${fasdBackendURL}/api/users/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newUser),
        });

        if (!response.ok) {
          const errorData = await response.json();
          console.error("Error data:", errorData);

          const backendErrorMessage =
            errorData.detail || "An error occurred. Please try again!";

          this.statusMessage = {
            class: "alert alert-danger",
            icon_class: "fa fa-times-circle",
            icon_title: `${backendErrorMessage}`,
            show: true,
          };
          return;
        }

        const result = await response.json();
        console.log("User registered successfully:", result);

        // Set success message
        this.statusMessage = {
          class: "alert alert-success mx-0",
          icon_class: "fa fa-check-circle",
          icon_title:
            "Your registration request has been submitted successfully! You will receive an email once it's approved by the admin.",
          show: true,
        };
        setTimeout(() => {
          this.$router.push({ path: "/authentication/page-login" });
        }, 7000);
      } catch (error) {
        console.error("Error registering user:", error);
        this.statusMessage = {
          class: "alert alert-danger",
          icon_class: "fa fa-times-circle",
          icon_title: `Your registration failed! ${error.message}`,
          show: true,
        };
      }
    },
  },
};
</script>

<style scoped>
.alert-message {
  display: flex;
  align-items: start;
  padding: 10px;
  margin-bottom: 15px;
  margin-top: 15px;
  border-radius: 4px;
  font-size: 14px;
  gap: 4px;
  width: 100%;
  max-width: 100%;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}
.alert-success .fa,
.alert-success i {
  color: #155724;
}

.alert-danger .fa,
.alert-danger i {
  color: #721c24;
}

.alert-message i {
  margin-top: 3px;
}
.message-content {
  display: inline-block;
}
.password-requirements p {
  margin: 0;
  font-size: 13px;
  color: #999;
}
.password-requirements p.valid {
  color: #28a745;
  font-weight: bold;
}
.footer-logos {
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
}
.footer-logo {
  height: 50px;
  width: auto;
  object-fit: contain;
}
.footer-logo-large {
  height: 70px;
}
.footer-logo-shift {
  margin-top: 10px;
}
</style>
